<script lang="ts">
  import { Accordion, AccordionItem } from "sveltestrap";
  import type { Diligence } from "../../../Model/Diligence";
  import AllListDataComplainants from "../../AllListDataComplainants.svelte";
  import type { Third } from "../../../Model/Third";
  import { complainantGenderService, complainantService, denouncedGenderService, denouncedService, witnessGenderService, witnessService } from "../../../services";
  import AddThirdModal from "../../AddThirdModal.svelte";
  import DiligenceComplainantGenderData from "./Data/DiligenceComplainantGenderData.svelte";
  import DiligenceAgressorGenderData from "./Data/DiligenceAgressorGenderData.svelte";
  import DiligenceWitnessGenderData from "./Data/DiligenceWitnessGenderData.svelte";
  import PoliceManifestationGenderData from "./Data/PoliceManifestationGenderData.svelte";
import FilesList from "../../FilesList.svelte";
    import PoliceManifestationInitialForm from "../Global/PoliceManifestationInitialForm.svelte";

  export let diligence: Diligence;

  type ThirdType = 'complainant' | 'aggressor' | 'witness';

  let complainantsThirds: Third[] = [];
  let complainantThird: Third;
  let complainantThirdId: string = '';

  let aggressorsThirds: Third[] = [];
  let aggressorThird: Third;
  let aggressorThirdId: string = '';

  let witnesssThirds: Third[] = [];
  let witnessThird: Third;
  let witnessThirdId: string = '';

  let openModal = false;
  let openComplainantModal = false;
  let openAggressorModal = false;
  let openWitnessModal = false;


  let onChangeThird: (event: CustomEvent<Third>) => Promise<void> = async () => {};

  $: loadForm(diligence);

  async function loadForm(diligence){
    await Promise.all([ 
        loadVictims(diligence),
        loadAggressors(diligence),
        loadWitness(diligence)
      ]) 
  }

  async function loadVictims(diligence){
    let opts = {
        offset : 0,
        limit : 25,
        filters: {
            diligenceId: diligence.id,
        }
    }

    complainantsThirds = await complainantGenderService.findThirds(opts);
    complainantsThirds.sort((a,b) => {
        return a.name < b.name ? -1 : 1;
    })
  }

  async function saveNewComplainantTraffic({ detail: third }: CustomEvent<Third>){
    await complainantService.createComplainant(third.id, diligence.id);
    await complainantGenderService.createComplainantGender(third.id, diligence.id);
    complainantsThirds.push(third);
    complainantsThirds = complainantsThirds;
  }

  async function openComplaintModal({detail}: CustomEvent<Third>){
    complainantThird = complainantsThirds.find(c => c.id == detail.id)
    if (complainantThird) {
      complainantThirdId = detail.id
      openComplainantModal = true
    }
  }

  async function loadAggressors(diligence){
    let opts = {
        offset : 0,
        limit : 25,
        filters: {
            diligenceId: diligence.id,
        }
    }

    aggressorsThirds = await denouncedGenderService.findThirds(opts);
    aggressorsThirds.sort((a,b) => {
        return a.name < b.name ? -1 : 1;
    })
  }

  async function saveNewAggressorTraffic({ detail: third }: CustomEvent<Third>){
    await denouncedService.createDenounced(third.id, diligence.id);
    await denouncedGenderService.createDenouncedGender(third.id, diligence.id);
    aggressorsThirds.push(third);
    aggressorsThirds = aggressorsThirds;
  }

  async function openActionAggressorModal({detail}: CustomEvent<Third>){
    aggressorThird = aggressorsThirds.find(c => c.id == detail.id)
    if (aggressorThird) {
      aggressorThirdId = detail.id
      openAggressorModal = true
    }
  }


  async function loadWitness(diligence){
  
  let opts = {
      offset : 0,
      limit : 100,
      filters: {
          diligenceId: diligence.id,
      }
  }

  witnesssThirds = await witnessService.findThirds(opts);
  witnesssThirds.sort((a,b) => {
      return a.name < b.name ? -1 : 1;
  })
  }

  async function saveNewWitnessTraffic({ detail: third }: CustomEvent<Third>){
        await witnessService.createWitness(third.id, diligence.id);
        witnesssThirds.push(third);
        witnesssThirds = witnesssThirds;
  }


  async function openActionWitnessModal({detail}: CustomEvent<Third>){
    witnessThird = witnesssThirds.find(c => c.id == detail.id)
    if (witnessThird) {
      witnessThirdId = detail.id
      openWitnessModal = true
    }
  }

  async function onAddNewThird(type: ThirdType){
    switch (type) {
      case 'complainant':
        onChangeThird = saveNewComplainantTraffic;
      break;
      case 'aggressor':
        onChangeThird = saveNewAggressorTraffic;
      break;
      case 'witness':
        onChangeThird = saveNewWitnessTraffic;
      break;
      default:
        throw new Error(`Error al obtener el type a guardar`);
    }

    openModal = true
  }

  function toggle() {
    openModal = !openModal;
  }
  function toggleComplainantModal(){
    openComplainantModal = !openComplainantModal
  }

  function toggleAggressorModal(){
    openAggressorModal = !openAggressorModal
  }

  function toggleWitnessModal(){
    openWitnessModal = !openWitnessModal
  }

  function saveComplainant(){
    loadForm(diligence);
  }

  async function deleteComplaiant(event) {
    await complainantGenderService.deleteComplainantGender(event.detail);

    await complainantService.deleteComplainantGlobal(event.detail);

    loadVictims(diligence)
  }

  async function deleteDenounced(event) {
    await denouncedGenderService.deleteDenouncedGender(event.detail);

    await denouncedService.deleteDenouncedGlobal(event.detail);

    loadAggressors(diligence)
  }

  async function deleteWitness(event) {
    await witnessGenderService.deleteWitness(event.detail);

    loadWitness(diligence)
  }

</script>

<Accordion>
  <AccordionItem header="Manifestación Policial Inicial">
    <PoliceManifestationInitialForm {diligence} />
  </AccordionItem>
  <AccordionItem header="Victimas">
      <AllListDataComplainants thirds={complainantsThirds} on:editThird={openComplaintModal} on:newThird={() => onAddNewThird('complainant')} on:deleteComplainant={deleteComplaiant}/>
  </AccordionItem>
  <AccordionItem header="Agresores">
      <AllListDataComplainants thirds={aggressorsThirds} on:editThird={openActionAggressorModal} on:newThird={() => onAddNewThird('aggressor')} on:deleteComplainant={deleteDenounced}/>
  </AccordionItem>
 <AccordionItem header="Testigos">
      <AllListDataComplainants thirds={witnesssThirds} on:editThird={openActionWitnessModal} on:newThird={() => onAddNewThird('witness')} on:deleteComplainant={deleteWitness}/>
  </AccordionItem>
  <AccordionItem header="Manifestación Policial">
    <PoliceManifestationGenderData diligence={diligence} />
  </AccordionItem>
  <AccordionItem header="Archivos">
    <FilesList contextId={diligence.id}/>
  </AccordionItem>
</Accordion>

<AddThirdModal
  open={openModal}
  {toggle}
  thirdId={complainantThirdId}
  on:changeThird={onChangeThird}
/>

<DiligenceComplainantGenderData 
  open={openComplainantModal}
  toggle={toggleComplainantModal}
  complainantThird={complainantThird} 
  diligenceId={diligence.id} 
  on:saveComplainant={(event) => saveComplainant()}
/>

<DiligenceAgressorGenderData
  open={openAggressorModal}
  toggle={toggleAggressorModal}
  agressorThird={aggressorThird} 
  diligenceId={diligence.id} 
  on:saveComplainant={(event) => saveComplainant()}
/>

<DiligenceWitnessGenderData
  open={openWitnessModal}
  toggle={toggleWitnessModal}
  witnessThird={witnessThird} 
  diligenceId={diligence.id} 
  on:saveWitness={(event) => saveComplainant()}
/>

  <style lang="scss">

    :global(.accordion){
      padding-right: 3px !important;
      padding-left: 3px !important;
    }
  
    :global(.accordion-item){
      border: 1px solid #dee2e6 !important;
      border-radius: 0.25rem !important;
    }
  
  
  </style>
  